class NeedALoanFamilySelectController {

  constructor(EventEmitter, $scope, $timeout, $location) {
    'ngInject';
    this.eventEmitter = EventEmitter;
    this.open = false;
    this.scope = $scope;
    this.timeout = $timeout;
    this.location = $location;
  }

  $onInit() {
    this.selectOptionOnPurpose();
    this.closeOnOutsideClick();
    if (this.isMobileApp) {
      this.scope.$watch(() => this.open, open => {
        open ? this.scrollToFamilySelectorAndAddPadding() : this.scrollToTopAndRemovePadding();
      });
    }
  }

  scrollToFamilySelectorAndAddPadding() {
    angular.element('#select-families-need-a-loan').css('padding-top', '60px');
    this.location.hash('select-families-need-a-loan');
  }

  scrollToTopAndRemovePadding() {
    angular.element('#select-families-need-a-loan').css('padding-top', '0px');
    this.location.hash('');
  }

  selectOptionOnPurpose() {
    this.scope.$watch(() => this.codeLoanSimulation, codeLoanSimulation => {
      if (codeLoanSimulation) {
        return this.purposeLiteral = this.findPurposeLiteral(codeLoanSimulation);
      }

      this.purposeLiteral = undefined;
    });
  }

  findPurposeLiteral(codeLoanSimulation) {
    const code = codeLoanSimulation.substring(0, 2);
    const familyCode = codeLoanSimulation.substring(2, 5);

    for (let key in this.families) {
      const family = this.families[key];

      if (family.code === familyCode) {
        const purpose = family.purposes.find(purpose => purpose.purposeCode === code);
        return purpose.purposeLiteral;
      }
    }
  }

  toggle() {
    this.resetSearchingTerm();
    this.open = !this.open;
  }

  closeOnOutsideClick() {
    $(document).click(event => {
      const target = $(event.target);
      const clickOutside = !target.closest('need-a-loan-family-select').length;

      if (clickOutside) {
        this.timeout(() => this.open = false);
      }
    });
  }

  getSelectClass() {
    return {
      blue: this.open,
    };
  }

  getArrowClass() {
    return {
      icon: true,
      'icon-arrow-select-down': !this.open,
      'icon-arrow-select-up': this.open,
    };
  }

  resetSearchingTerm() {
    this.searchingTerm = '';
  }

  getPurposeClass(purpose) {
    if (!this.searchingTerm) {
      return {};
    }

    const literal = purpose.purposeLiteral.toLowerCase();
    const searchingTerm = this.searchingTerm.toLowerCase();
    const highlight = literal.indexOf(searchingTerm) > -1;
    return { highlight };
  }

  selectPurpose(key, family, purpose) {
    this.purposeLiteral = purpose.purposeLiteral;
    this.toggle();

    this.onOptionSelect(this.eventEmitter({
      familyName: key,
      familyCode: family.code,
      purposeCode: purpose.purposeCode,
    }));
  }

}

export default NeedALoanFamilySelectController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanFamilySelect/needALoanFamilySelect.controller.js